import axios from 'axios'

export default axios.create({
    baseURL: 'https://tianqi.tqzl-tech.com/api',
    // baseURL: 'http://192.168.1.60:9898',
    timeout: 10000
})



// WEBPACK FOOTER //
// ./src/api/index.js